import Table from "../../../../Components/Table"
import { ADMIN_PAGE_SIZE } from "../../constants/columns"

// The admin disputes table. Wraps the shared antd Table with this page's layout decisions
// so the page file stays about state; sorting and paging are handed back through
// `onChange`, which is also what drives the refetch in useAdminDisputesQuery.
const AdminDisputesTable = ({
  loading,
  results,
  columns,
  count,
  page,
  onChange,
  onRowClick,
  EmptyComponent
}) => (
  <Table
    loading={loading}
    dataSource={results}
    columns={columns}
    rowKey="id"
    rowHoverable
    // Constrain the body so it scrolls inside the table (sticky header + pagination pinned
    // at the bottom) instead of the page growing past 50 rows.
    scroll={{ x: "max-content", y: "calc(100vh - 330px)" }}
    pagination={{ current: page, pageSize: ADMIN_PAGE_SIZE, total: count, showSizeChanger: false }}
    onChange={onChange}
    EmptyComponent={EmptyComponent}
    onRow={(record) => ({ onClick: () => onRowClick(record) })}
    className="disputes-table"
  />
)

export default AdminDisputesTable
